<template>
  <layout-content>
    <create-form />
  </layout-content>
</template>
<script>
  import CreateForm from '@projects/components/imports-select-fields';
  export default {
    components: { CreateForm }
  };
</script>
